import { useMemo } from 'react';

import BooleanInputs from './BooleanInputs';
import { inputStyle as inputStyleClass } from './Survey.css';
import { getInputStyle } from './utils';

interface Props {
  name: string;
  id?: string;
  type: string;
  required: boolean;
  inputStyle?: React.CSSProperties;
  isHidden?: boolean;
  placeholder?: string;
  overrideEmailFieldIdentifier?: boolean;
}

const ShortText = ({
  id,
  name,
  type,
  required,
  inputStyle = {},
  isHidden = false,
  placeholder,
  overrideEmailFieldIdentifier = false,
}: Props) => {
  const style = useMemo(() => getInputStyle(inputStyle), [inputStyle]);

  switch (type) {
    case 'email':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={overrideEmailFieldIdentifier ? name : 'email'}
          type="email"
          hidden={isHidden}
          required={required}
          placeholder={placeholder || 'Email'}
          id={overrideEmailFieldIdentifier ? id : 'email'}
        />
      );
    case 'string':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="text"
          required={required}
          placeholder={placeholder || 'Please type your response here'}
          id={name}
        />
      );
    case 'integer':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="number"
          required={required}
          placeholder={placeholder || 'Number'}
          id={name}
        />
      );
    case 'boolean':
      return <BooleanInputs name={name} required={required} />;
    case 'date':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="date"
          placeholder={placeholder || 'date'}
          required={required}
          id={name}
        />
      );
    case 'datetime':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="time"
          placeholder={placeholder || 'time'}
          required={required}
          id={name}
        />
      );
    default:
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="text"
          placeholder={placeholder || 'Please type your response here'}
          required={required}
          id={name}
        />
      );
  }
};

export default ShortText;
